import { useSelector } from 'src/hooks/useSelector';

const MAP_FILTERS_HIDDEN_FROM_USER_COUNT = 6;

export const useTotalVacancyFiltersCount = (isMapPage = false) => {
    let totalUsedVacancyFilters = useSelector((state) => state.vacancySearchResult.totalUsedFilters) || 0;

    // TODO: перенести расчет этих параметров на бэкенд https://jira.hh.ru/browse/HH-223905 после эксперимента
    const criteriaText = useSelector((state) => state.vacancySearchResult.criteria?.text);
    const resume = useSelector((state) => state.vacancySearchResult.criteria?.resume);
    totalUsedVacancyFilters = criteriaText ? totalUsedVacancyFilters - 1 : totalUsedVacancyFilters;
    totalUsedVacancyFilters = resume ? totalUsedVacancyFilters + 1 : totalUsedVacancyFilters;

    if (isMapPage) {
        return totalUsedVacancyFilters - MAP_FILTERS_HIDDEN_FROM_USER_COUNT;
    }

    return totalUsedVacancyFilters;
};
